// extracted by mini-css-extract-plugin
export default {"tagWrapper":"zNIhEgbFLl_product-carousel","icon":"ylvobc2XF0_product-carousel","textWrap":"U6txan84Vq_product-carousel","bestPriceTagText":"Rcsbti6Eyg_product-carousel"};